import { ReactNode } from 'react';

import { ToolExtensions } from '@spotify/plugin-confidence-chat-react';

import {
  GetPullRequestDiffToolExtension,
  GetPullRequestToolExtension,
  GlobFilesToolExtension,
  ListPullRequestsToolExtension,
  ListRepositoriesToolExtension,
  ReadFileToolExtension,
  SearchCodeToolExtension,
  SearchPullRequestsToolExtension,
} from './CodeExplorerToolExtensions';
import { CreateChartBlockToolExtension } from './CreateChartBlockToolExtension';
import { CreateChartToolExtension } from './CreateChartToolExtension';
import { CreateSubagentToolExtension } from './CreateSubagentToolExtension';
import { CreateTableBlockToolExtension } from './CreateTableBlockToolExtension';
import { DataDiscoveryToolExtension } from './DataDiscoveryToolExtensions';
import { DocumentToolExtension } from './DocumentToolExtension';
import { DrawToolExtension } from './DrawToolExtension';
import { ExecuteSqlToolExtension } from './ExecuteSqlToolExtension';
import {
  IssueToolExtension,
  ObservationToolExtension,
  TaskToolExtension,
} from './IssueObservationToolExtensions';
import {
  BundleToolExtension,
  ConceptToolExtension,
} from './KnowledgeToolExtensions';
import { LoadToolsToolExtension } from './LoadToolsToolExtension';
import {
  CreateFlagPreviewExtension,
  CreateMetricPreviewExtension,
  CreateSegmentPreviewExtension,
  UpdateFlagPreviewExtension,
  UpdateFlagVariantPreviewExtension,
} from './McpToolPreviewExtensions';
import {
  ListDataSourcesToolExtension,
  QueryDataSourcesToolExtension,
} from './PlatformInsightsToolExtensions';
import { SaveToPulseToolExtension } from './SaveToPulseToolExtension';
import { SkillToolExtension } from './SkillToolExtension';
import { TodoWriteToolExtension } from './TodoWriteToolExtension';
import {
  WebFetchToolExtension,
  WebSearchToolExtension,
} from './WebResearchToolExtensions';

type DefaultChatToolExtensionsProps = {
  toolExtensions?: ReactNode;
  previewExtensions?: ReactNode;
};

export const DefaultChatToolExtensions = ({
  toolExtensions,
  previewExtensions,
}: DefaultChatToolExtensionsProps) => (
  <ToolExtensions>
    {toolExtensions}
    <CreateChartToolExtension />
    <CreateChartBlockToolExtension />
    <CreateTableBlockToolExtension />
    <CreateSubagentToolExtension />
    <DocumentToolExtension />
    <ConceptToolExtension />
    <BundleToolExtension />
    <DrawToolExtension />
    <ReadFileToolExtension />
    <ListRepositoriesToolExtension />
    <SearchCodeToolExtension />
    <GlobFilesToolExtension />
    <ListPullRequestsToolExtension />
    <GetPullRequestToolExtension />
    <GetPullRequestDiffToolExtension />
    <SearchPullRequestsToolExtension />
    <WebSearchToolExtension />
    <WebFetchToolExtension />
    <ExecuteSqlToolExtension />
    <DataDiscoveryToolExtension />
    <ListDataSourcesToolExtension />
    <QueryDataSourcesToolExtension />
    <IssueToolExtension />
    <ObservationToolExtension />
    <TaskToolExtension />
    <SaveToPulseToolExtension />
    <SkillToolExtension />
    <LoadToolsToolExtension />
    <TodoWriteToolExtension />
    <CreateFlagPreviewExtension />
    <UpdateFlagPreviewExtension />
    <UpdateFlagVariantPreviewExtension />
    {previewExtensions}
    <CreateMetricPreviewExtension />
    <CreateSegmentPreviewExtension />
  </ToolExtensions>
);
